import {
  GET_INBOX_CHAT_USERS,
  GET_INBOX_CHAT_USERS_SUCCESS,
  GET_INBOX_MESSAGES,
  GET_INBOX_MESSAGES_FAILED,
  GET_INBOX_MESSAGES_SUCCESS,
  GET_MESSAGE_LIKES_SUCCESS,
  INBOX_DISCONNECT,
  INCREMENT_UNREAD_MESSAGE_COUNT,
  INIT_INBOX_SESSION,
  INIT_INBOX_SESSION_FAILED,
  INIT_INBOX_SESSION_SUCCESS,
  LOAD_INBOX_MESSAGES,
  LOAD_INBOX_MESSAGES_SUCCESS,
  RESET_UNREAD_MESSAGE_COUNTER,
  SAVE_COMMENT_BOARD_DIALOGS,
  SAVE_DIRECT_MESSAGE_DIALOGS,
  SAVE_DIRECT_MESSAGE_USERS,
  SAVE_NEW_INBOX_MESSAGE,
  SAVE_NEWS_FEED_DIALOGS,
  SEND_INBOX_MESSAGE,
  SEND_INBOX_MESSAGE_FAILED,
  SEND_INBOX_MESSAGE_SUCCESS,
  UPDATE_MESSAGE_LIKES_SUCCESS,
} from "./actionTypes"

const INIT_STATE = {
  qbConnected: false,
  commentBoardDialogs: null,
  directMessageDialogs: null,
  newsFeedDialogs: null,
  inboxSessionIsLoading: false,
  directMessageUserMap: {},
  messageListIsLoading: false,
  messages: null,
  inboxSession: null,
  chatUsers: [],
  likes: [],
  sendingMessage: false,
}

const Inbox = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_COMMENT_BOARD_DIALOGS:
      return {
        ...state,
        commentBoardDialogs: action.payload,
      }
    case SAVE_DIRECT_MESSAGE_DIALOGS:
      return {
        ...state,
        directMessageDialogs: action.payload,
      }
    case SAVE_NEWS_FEED_DIALOGS:
      return {
        ...state,
        newsFeedDialogs: action.payload,
      }
    case INIT_INBOX_SESSION:
      return {
        ...state,
        inboxSessionIsLoading: true,
      }
    case INIT_INBOX_SESSION_FAILED:
      return {
        ...state,
        inboxSessionIsLoading: false,
      }
    case INIT_INBOX_SESSION_SUCCESS:
      return {
        ...state,
        inboxSessionIsLoading: false,
        qbConnected: true,
        inboxSession: action.payload,
      }
    case SAVE_DIRECT_MESSAGE_USERS:
      return {
        ...state,
        directMessageUserMap: action.payload,
      }
    case LOAD_INBOX_MESSAGES_SUCCESS:
      return {
        ...state,
        messages: action.payload
          ? {
              ...action.payload,
              items: [...action.payload?.items.reverse(), ...(state?.messages?.items || [])],
              showLoadMore: action.payload?.limit <= action.payload?.items?.length
            }
          : state.messages,
      }
    case GET_INBOX_MESSAGES:
      return {
        ...state,
        messages: null,
        messageListIsLoading: true,
      }
    case GET_INBOX_MESSAGES_FAILED:
      return {
        ...state,
        messageListIsLoading: false,
      }
    case GET_INBOX_MESSAGES_SUCCESS:
      return {
        ...state,
        // messages: action.payload?.reverse(),
        messages: action.payload
        ? {
            ...action.payload,
            items: [...action.payload?.items.reverse(), ...(state?.messages?.items || [])],
            showLoadMore: action.payload?.limit <= action.payload?.items?.length
          }
        : state.messages,
        messageListIsLoading: false,
      }
    case INBOX_DISCONNECT:
      return {
        ...state,
        qbConnected: false,
        commentBoardDialogs: null,
        directMessageDialogs: null,
        newsFeedDialogs: null,
        messages: null,
        inboxSession: null,
      }
    case RESET_UNREAD_MESSAGE_COUNTER:
      const selectedDialog = state.directMessageDialogs?.items.find(
        dialog => dialog._id === action.payload.dialogId
      )
      if (!selectedDialog) return state
      const selectedUnreadCount = selectedDialog?.unread_messages_count

      return {
        ...state,
        directMessageDialogs: {
          ...state.directMessageDialogs,
          unreadCount:
            state.directMessageDialogs?.unreadCount - selectedUnreadCount,
          items: state.directMessageDialogs?.items.map(dialog =>
            dialog._id === action.payload.dialogId
              ? { ...dialog, unread_messages_count: 0 }
              : dialog
          ),
        },
      }
    case INCREMENT_UNREAD_MESSAGE_COUNT:
      return {
        ...state,
        directMessageDialogs: {
          ...state.directMessageDialogs,
          items: state.directMessageDialogs?.items?.map(dialog =>
            dialog._id === action.payload.dialogId
              ? {
                  ...dialog,
                  unread_messages_count: dialog.unread_messages_count + 1,
                }
              : dialog
          ),
        },
      }
    case GET_INBOX_CHAT_USERS_SUCCESS:
      return {
        ...state,
        chatUsers: action.payload,
      }
    case SAVE_NEW_INBOX_MESSAGE:
      if (
        state?.messages?.items?.find(messages => messages._id === action.payload?._id)
      ) {
        return state
      } else {
        return {
          ...state,
          messages: {...state.messages, items: [...state.messages.items, action.payload]},
        }
      }
    case GET_MESSAGE_LIKES_SUCCESS:
      return {
        ...state,
        likes: action.payload,
      }
    case UPDATE_MESSAGE_LIKES_SUCCESS:
      const index = state.likes.findIndex(
        like => like?.message_qb_id === action?.payload?.message_qb_id
      )
      if (index !== -1) {
        return {
          ...state,
          likes: state.likes.map((like, i) =>
            i === index ? action.payload : like
          ),
        }
      } else {
        return {
          ...state,
          likes: [...state.likes, action.payload],
        }
      }
    case SEND_INBOX_MESSAGE:
      return {
        ...state,
        sendingMessage: true,
      }
    case SEND_INBOX_MESSAGE_FAILED:
    case SEND_INBOX_MESSAGE_SUCCESS:
      return {
        ...state,
        sendingMessage: false,
      }
    default:
      return state
  }
}

export default Inbox
